import React from 'react';
import { Button } from '@material-ui/core';

import errorUtils from 'utils/error';

export default function useSnackBar() {
  return {
    showMessage: (enqueueSnackbar, { message, options = {} } = {}) => {
      let messageToDisplay = null;

      messageToDisplay =
        options.variant === 'error' ? errorUtils.parseError(message) : message;

      if (messageToDisplay) {
        enqueueSnackbar(
          messageToDisplay,
          Object.assign(
            {},
            {
              action: <Button size="small">Dismiss</Button>,
              preventDuplicate: false
            },
            options
          )
        );
      }
    }
  };
}
